import { render, staticRenderFns } from "./TableOnlyRequirements.vue?vue&type=template&id=8233a3d0&"
import script from "./TableOnlyRequirements.vue?vue&type=script&lang=js&"
export * from "./TableOnlyRequirements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports